var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 .25a.75.75 0 010 1.5H3.75v5.5h8.5v-5.5H11a.75.75 0 010-1.5h4a.75.75 0 010 1.5h-1.25v12.5H15a.75.75 0 010 1.5h-4a.75.75 0 010-1.5h1.25v-5.5h-8.5v5.5H5a.75.75 0 010 1.5H1a.75.75 0 010-1.5h1.25V1.75H1a.75.75 0 010-1.5h4z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeader);
export default __webpack_public_path__ + "static/media/header.b95d552f2ac1ded610a1e4d0d5688875.svg";
export { ForwardRef as ReactComponent };